import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { Modal, Spinner } from "react-bootstrap";
import Swal from "sweetalert2";
import axios from "axios";

import "./style.css";
import ScrollToTop from "../../../../../components/scrollToTop/scrollToTop";
import AcceptanceDetails from "./acceptanceDetails";

const Acceptance = () => {
  const [masterValue, setMasterValue] = useState("");
  const [data, setData] = useState({});
  const [loanding, setLoanding] = useState(false);
  const [view, setView] = useState("input");
  const [error, setError] = useState("");

  const handleMaster = async () => {
    const regex = /^\d{3}-\d{8}$/;
    if (!masterValue.trim()) {
      setError("Este campo es obligatorio");
      return;
    }
    if (!regex.test(masterValue)) {
      setError("Formato de master invalido");
      return;
    }
    setLoanding(true);

    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_BACKEND}/api/v1/expo_acceptance/assignmentCargoAcceptance/${masterValue}`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );

      if (res.data.code === 1) {
        setData(res.data.data);
        setTimeout(() => {
          setView("details");
          setLoanding(false);
        }, 1000);
      } else if (res.data.code === -1) {
        setLoanding(false);
        Swal.fire({
          title: "La master no existe favor de verificar",
          icon: "warning",
          iconColor: "#FCC732",
          customClass: {
            confirmButton: "btn-ok",
            title: "alert-title",
            popup: "alert-bg",
          },
        });
        return;
      }
    } catch (error) {
      console.error(error);
      Swal.fire({
        title: "Hubo un error inesperado",
        icon: "error",
        iconColor: "#f90034}",
        customClass: {
          confirmButton: "btn-ok",
          title: "alert-title",
          popup: "alert-bg",
        },
      });
    }
  };

  return (
    <>
      <Helmet>
        <title>Horus | Aceptación</title>
      </Helmet>
      <ScrollToTop />
      <div className="container-fluid">
        {view === "input" && (
          <div className="row justify-content-center">
            <div className="col-6">
              <label htmlFor="inputMaster" class="amc-label">
                Master
              </label>
              <input
                type="text"
                class="form-control"
                id="inputMaster"
                value={masterValue}
                onChange={(e) => setMasterValue(e.target.value)}
              />
              {error && <small className="text-danger">{error}</small>}
              <div className="btns mt-3 d-flex justify-content-end gap-3">
                <button className="btnn" onClick={handleMaster}>
                  Buscar
                </button>
              </div>
            </div>
          </div>
        )}
        {view === "details" && (
          <AcceptanceDetails data={data} setData={setData} setView={setView} />
        )}
      </div>

      <Modal
        show={loanding}
        onHide={() => {
          setLoanding(false);
        }}
        backdrop="static"
        keyboard={false}
        centered
        dialogClassName="custom-modal"
        backdropClassName="custom-backdrop"
      >
        <div className="spinner-container">
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Cargando...</span>
          </Spinner>
        </div>
      </Modal>
    </>
  );
};

export default Acceptance;
